import * as React from 'react';
import type { SVGProps } from 'react';

const IconWave = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="16" fill="none" {...props}>
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        clipPath="url(#a)"
      >
        <path d="M1.285 5.043v6.815M21.52 5.453v5.997M5.331 2.87v10.354M17.474 3.677v9.547M13.426 1.331V12.41M9.38 5.043v9.59" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h22.805v15.964H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconWave;
